// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-col-spin {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.delivery-container {
  margin-top: 20px;
  max-width: 100%;
  width: 100%;
  justify-content: center;
}
.delivery-container .ant-row {
  width: 100%;
}
.delivery-container .ant-row .ant-col {
  width: 100%;
}
.delivery-container .ant-row .ant-col .ant-card {
  border-radius: 8.5px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  width: 100%;
  overflow: hidden;
}
.delivery-container .ant-row .ant-col .ant-card .icon-center {
  position: absolute;
  top: 5px;
  right: 8px;
}

.active_user {
  border: 3px solid rgb(17, 255, 0);
  width: 30px;
  height: 30px;
  border-radius: 50px;
}

.inactive_user {
  border: 3px solid rgb(154, 0, 0);
  width: 30px;
  height: 30px;
  border-radius: 50px;
}

.delivery .map-container {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
}
.delivery .map-container .gmnoprint {
  position: absolute;
  top: 70%;
}
.delivery .map-user-card {
  position: absolute;
  z-index: 99;
  left: 10px;
  bottom: 10px;
  width: calc(100% - 20px);
  margin: 0;
  border: 1px solid var(--border-color);
}
.delivery .map-user-card .title {
  font-weight: 700;
}
.delivery .map-user-card .close-btn {
  padding: 5px;
  cursor: pointer;
  border: none;
  outline: none;
  background: transparent;
}
.delivery .map-user-card.with-order {
  bottom: 0;
}
.delivery .user-card {
  border: 1px solid var(--border-color);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.delivery .user-card.active {
  border-color: var(--box-shadow);
}
.delivery .user-card .title {
  font-size: 16px;
  margin-bottom: 0;
}
.delivery .user-card .last-seen {
  font-size: 14px;
}
.delivery .user-card .last-seen.online {
  color: #38c988;
}
.delivery .user-card .img-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  overflow: hidden;
}
.delivery .user-card .img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.delivery .order-list {
  height: 75vh;
  overflow-y: auto;
  overflow-y: auto;
}

[data-theme=dark] .deliveryman-card {
  background: #1b2531 !important;
  border: 1px solid transparent !important;
}

[data-theme=dark] .map_cart {
  background: #1b2531 !important;
}

[data-theme=dark] .user-card {
  border: 1px solid var(--border-color-bg-dark) !important;
}

[data-theme=dark] .map-user-card {
  border: 1px solid var(--border-color-bg-dark) !important;
}

.modal_container {
  display: grid;
  width: 100%;
  grid-template-columns: auto auto;
  gap: 20px;
}
.modal_container .modal_card {
  display: flex;
  width: 100%;
  min-height: 200px;
  box-shadow: 0 0 13px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
}
.modal_container .modal_card.blue {
  border-left: 8px solid #3e79f7;
}
.modal_container .modal_card.red {
  border-left: 8px solid #f86b72;
}
.modal_container .modal_card.cyan {
  border-left: 8px solid #38c988;
}
.modal_container .modal_card .header .circle-1 {
  width: 10px;
  height: 10px;
  background: #ffffff;
  border-radius: 50px;
}
.modal_container .modal_card .header .circle-2 {
  width: 10px;
  height: 10px;
  background: #ffffff;
  border-radius: 50px;
}
.modal_container .modal_card .header .circle-3 {
  width: 10px;
  height: 10px;
  background: #ffffff;
  border-radius: 50px;
}
.modal_container .modal_card .card_left {
  border-right: 1px solid #4d5b75;
  padding-right: 12px;
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: space-between;
}
.modal_container .modal_card .card_left .card_left_price {
  font-size: 20px;
  width: 100%;
  text-align: center;
}
.modal_container .modal_card .card_left .card_left_days {
  font-size: 16px;
  width: 100%;
  text-align: center;
}
.modal_container .modal_card .card_right {
  margin: 10px 0 0 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}
.modal_container .modal_card .card_right .card_right_id {
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
}
.modal_container .modal_card .card_right .card_right_id .card_right_id_text {
  font-size: 12px;
}
.modal_container .modal_card .card_right .card_right_id .card_right_id_value {
  font-size: 22px;
}
.modal_container .modal_card .card_right .card_right_address {
  width: 100%;
}
.modal_container .modal_card .card_right .card_right_data {
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: space-between;
}
.modal_container .modal_card .card_right .card_right_data .card_status {
  width: 100%;
  text-align: center;
}
.modal_container .modal_card .card_right .card_right_data .card_status .card_status_text {
  font-size: 12px;
}
.modal_container .modal_card .card_right .card_right_data .card_status .card_status_value {
  height: 27px;
  padding-top: 5px;
}

.circle {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/delivery.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AACF;AACE;EACE,WAAA;AACJ;AACI;EACE,WAAA;AACN;AACM;EACE,oBAAA;EACA,uCAAA;EACA,WAAA;EACA,gBAAA;AACR;AACQ;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AACV;;AAKA;EACE,iCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAIA;EACE,gCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAEI;EACE,kBAAA;EACA,QAAA;AAAN;AAGE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;EACA,SAAA;EACA,qCAAA;AADJ;AAEI;EACE,gBAAA;AAAN;AAEI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AAAN;AAEI;EACE,SAAA;AAAN;AAGE;EACE,qCAAA;EACA,eAAA;EACA,gCAAA;AADJ;AAEI;EACE,+BAAA;AAAN;AAEI;EACE,eAAA;EACA,gBAAA;AAAN;AAEI;EACE,eAAA;AAAN;AAEI;EACE,cAAA;AAAN;AAEI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAAN;AACM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AACR;AAGE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AADJ;;AAKA;EACE,8BAAA;EACA,wCAAA;AAFF;;AAIA;EACE,8BAAA;AADF;;AAGA;EACE,wDAAA;AAAF;;AAEA;EACE,wDAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,gCAAA;EACA,SAAA;AACF;AAAE;EACE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;AAEJ;AADI;EACE,8BAAA;AAGN;AADI;EACE,8BAAA;AAGN;AADI;EACE,8BAAA;AAGN;AAAM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAER;AAAM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAER;AAAM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAER;AACI;EACE,+BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;AACN;AACM;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AACR;AACM;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AACR;AAEI;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AAAN;AACM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,kBAAA;AACR;AAAQ;EACE,eAAA;AAEV;AAAQ;EACE,eAAA;AAEV;AACM;EACE,WAAA;AACR;AACM;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;AACR;AAAQ;EACE,WAAA;EACA,kBAAA;AAEV;AADU;EACE,eAAA;AAGZ;AADU;EACE,YAAA;EACA,gBAAA;AAGZ;;AAKA;EACE,kBAAA;AAFF","sourcesContent":[".ant-col-spin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n}\n\n.delivery-container {\n  margin-top: 20px;\n  max-width: 100%;\n  width: 100%;\n  justify-content: center;\n\n  .ant-row {\n    width: 100%;\n\n    .ant-col {\n      width: 100%;\n\n      .ant-card {\n        border-radius: 8.5px;\n        box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\n        width: 100%;\n        overflow: hidden;\n\n        .icon-center {\n          position: absolute;\n          top: 5px;\n          right: 8px;\n        }\n      }\n    }\n  }\n}\n.active_user {\n  border: 3px solid rgb(17, 255, 0);\n  width: 30px;\n  height: 30px;\n  border-radius: 50px;\n}\n.inactive_user {\n  border: 3px solid rgb(154, 0, 0);\n  width: 30px;\n  height: 30px;\n  border-radius: 50px;\n}\n.delivery {\n  .map-container {\n    position: relative;\n    overflow: hidden;\n    border-radius: 12px;\n    .gmnoprint {\n      position: absolute;\n      top: 70%;\n    }\n  }\n  .map-user-card {\n    position: absolute;\n    z-index: 99;\n    left: 10px;\n    bottom: 10px;\n    width: calc(100% - 20px);\n    margin: 0;\n    border: 1px solid var(--border-color);\n    .title {\n      font-weight: 700;\n    }\n    .close-btn {\n      padding: 5px;\n      cursor: pointer;\n      border: none;\n      outline: none;\n      background: transparent;\n    }\n    &.with-order {\n      bottom: 0;\n    }\n  }\n  .user-card {\n    border: 1px solid var(--border-color);\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n    &.active {\n      border-color: var(--box-shadow);\n    }\n    .title {\n      font-size: 16px;\n      margin-bottom: 0;\n    }\n    .last-seen {\n      font-size: 14px;\n    }\n    .last-seen.online {\n      color: #38c988;\n    }\n    .img-wrapper {\n      width: 40px;\n      height: 40px;\n      border-radius: 10px;\n      overflow: hidden;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n  .order-list {\n    height: 75vh;\n    overflow-y: auto;\n    overflow-y: auto;\n  }\n}\n\n[data-theme='dark'] .deliveryman-card {\n  background: #1b2531 !important;\n  border: 1px solid transparent !important;\n}\n[data-theme='dark'] .map_cart {\n  background: #1b2531 !important;\n}\n[data-theme='dark'] .user-card {\n  border: 1px solid var(--border-color-bg-dark) !important;\n}\n[data-theme='dark'] .map-user-card {\n  border: 1px solid var(--border-color-bg-dark) !important;\n}\n\n.modal_container {\n  display: grid;\n  width: 100%;\n  grid-template-columns: auto auto;\n  gap: 20px;\n  .modal_card {\n    display: flex;\n    width: 100%;\n    min-height: 200px;\n    box-shadow: 0 0 13px rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    padding: 12px 16px;\n    &.blue {\n      border-left: 8px solid #3e79f7;\n    }\n    &.red {\n      border-left: 8px solid #f86b72;\n    }\n    &.cyan {\n      border-left: 8px solid #38c988;\n    }\n    .header {\n      .circle-1 {\n        width: 10px;\n        height: 10px;\n        background: #ffffff;\n        border-radius: 50px;\n      }\n      .circle-2 {\n        width: 10px;\n        height: 10px;\n        background: #ffffff;\n        border-radius: 50px;\n      }\n      .circle-3 {\n        width: 10px;\n        height: 10px;\n        background: #ffffff;\n        border-radius: 50px;\n      }\n    }\n    .card_left {\n      border-right: 1px solid #4d5b75;\n      padding-right: 12px;\n      width: 25%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      flex-wrap: wrap;\n      flex-direction: row;\n      align-content: space-between;\n\n      .card_left_price {\n        font-size: 20px;\n        width: 100%;\n        text-align: center;\n      }\n      .card_left_days {\n        font-size: 16px;\n        width: 100%;\n        text-align: center;\n      }\n    }\n    .card_right {\n      margin: 10px 0 0 10px;\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n      position: relative;\n      .card_right_id {\n        position: absolute;\n        top: 0;\n        right: 0;\n        text-align: center;\n        .card_right_id_text {\n          font-size: 12px;\n        }\n        .card_right_id_value {\n          font-size: 22px;\n        }\n      }\n      .card_right_address {\n        width: 100%;\n      }\n      .card_right_data {\n        width: 100%;\n        display: flex;\n        text-align: center;\n        justify-content: space-between;\n        .card_status {\n          width: 100%;\n          text-align: center;\n          .card_status_text {\n            font-size: 12px;\n          }\n          .card_status_value {\n            height: 27px;\n            padding-top: 5px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.circle {\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
